"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BeautyAndTrends = require("./BeautyAndTrends");
Object.keys(_BeautyAndTrends).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BeautyAndTrends[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BeautyAndTrends[key];
    }
  });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
